import Url from "nexia_mobile/url";
import Schema from "nexia_mobile/models/schema";

export default {
  parseLinksFilter(links) {
    const link = links[0];
    if (link) {
      const FilterSchema = this.getFilterSchemaClass();
      this._filterSchema = new FilterSchema(link.getData(), { parse: true });
      this._filterTemplateLink = link.href;
      if (this.clonedResource) {
        this.clonedResource._filterSchema = this._filterSchema;
        this.clonedResource._filterTemplateLink = this._filterTemplateLink;
      }
    } else {
      this._filterSchema = null;
      this._filterTemplateLink = null;
      if (this.clonedResource) {
        this.clonedResource._filterSchema = null;
        this.clonedResource._filterTemplateLink = null;
      }
    }
  },

  getFilterSchemaClass() {
    return Schema;
  },

  getFilterSchema() {
    return this._filterSchema;
  },

  applyFilterParams() {
    const filterLink = Url.expandTemplate(
      this._filterTemplateLink,
      this._filterSchema.attributes
    );
    return this.fetchUrlWithResourceClone(filterLink).then((newCollection) => {
      this.reset(newCollection.models);
    });
  },

  clearFilter() {
    const defaultValues = this._filterSchema.get("default_values");
    this._filterSchema.set(defaultValues);
    this._filterSchema.schemaFields = this._filterSchema.schemaFields.map(
      (field) => {
        return {
          ...field,
          value: defaultValues[field.name],
        };
      }
    );
    this.trigger("sync"); // Re-render collection if necessary
  },
};



// WEBPACK FOOTER //
// ./src/models/mixins/filterable.js